export enum ClaimType
{
    Bank,
    Rent,
    Delivery,
    Salary,
    Tax,
    Other
}